import React from 'react';
import { Button } from '@components';
import '../../styles.css';

export const InstrucaoPA = ({ setExibirInstrucao }) => {
  return (
    <div className="ms-0">
      <ol className="ts-16 ps-3 lh-base text-muted mb-32 text-justify">
        <li className="mb-3">
          <b>Informe sua matrícula:</b> no passo seguinte, você deverá inserir a
          matrícula que foi enviada por e-mail pela Forluz e clicar em Enviar.
          Essa matrícula é única e intransferível, serve como uma identificação
          no nosso sistema.
        </li>
        <li className="mb-3">
          <b>Recebimento do Token de Verificação:</b> você receberá no seu
          e-mail e/ou telefone cadastrado em nosso sistema um token de
          verificação. Esse dado é necessário para continuar o processo de
          cadastramento da senha.
        </li>
        <li className="mb-3">
          <b>Insira seu token:</b> o token recebido, deverá ser inserido no
          campo obrigatório. Em seguida clique no botão enviar. Essa etapa
          valida sua identidade e garante a segurança do processo de mudança de
          senha, assegurando que somente você terá acesso a nova senha.
        </li>
        <li className="mb-3">
          <b>Nova senha:</b> será solicitada a criação da nova senha.
          Certifique-se que ela atenderá aos critérios de segurança exigidos:
          ter letra e número e no mínimo 6 dígitos. Depois da criação e
          confirmação, o processo estará concluído e sua nova senha será
          ativada. Vamos lá?
        </li>
      </ol>
      <Button className="mt-32 ts-14" onClick={() => setExibirInstrucao(false)}>
        Prosseguir
      </Button>
    </div>
  );
};
